module.exports = __webpack_public_path__ + "static/media/button_icon_tell.21c7be86.svg";